import React from 'react';

interface SearchIconProps {
  className?: string;
}

const SearchIcon: React.FC<SearchIconProps> = ({ className = '' }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="16" 
      height="16" 
      viewBox="0 0 16 16" 
      fill="none"
      className={className}
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M7.33333 1C3.83667 1 1 3.83667 1 7.33333C1 10.83 3.83667 13.6667 7.33333 13.6667C8.84333 13.6667 10.2267 13.14 11.3167 12.26L13.7667 14.71C14.0267 14.97 14.45 14.97 14.71 14.71C14.97 14.45 14.97 14.0267 14.71 13.7667L12.26 11.3167C13.14 10.23 13.6667 8.84333 13.6667 7.33333C13.6667 3.83667 10.83 1 7.33333 1ZM2.33333 7.33333C2.33333 4.57333 4.57333 2.33333 7.33333 2.33333C10.0933 2.33333 12.3333 4.57333 12.3333 7.33333C12.3333 10.0933 10.0933 12.3333 7.33333 12.3333C4.57333 12.3333 2.33333 10.0933 2.33333 7.33333ZM8.61 3.92C8.20667 3.75333 7.77333 3.66667 7.33333 3.66667C6.41333 3.66667 5.58 4.04 4.97667 4.64333C4.71667 4.90333 4.71667 5.32667 4.97667 5.58667C5.23667 5.84667 5.66 5.84667 5.92 5.58667C6.28333 5.22333 6.78333 5 7.33333 5C7.59667 5 7.85667 5.05 8.09667 5.15C8.34 5.25 8.56 5.39667 8.74333 5.58333C9.00333 5.84333 9.42667 5.84333 9.68667 5.58333C9.94667 5.32333 9.94667 4.9 9.68667 4.64C9.37667 4.33 9.01 4.08333 8.60333 3.91667L8.61 3.92Z" 
        fill="#A2A9B0"
      />
    </svg>
  );
};

export default SearchIcon;